import http, {reqDefaultConfig} from "./http";
import {useRequest} from "ahooks";

const apiPath = {
  qryOrderListForApp: '/order/orderBase/qryOrderListForApp',
  getOrderInfoById: '/order/orderBase/getOrderInfoById',
  cancelOrder: '/order/orderBase/cancelOrder',
  createOrderByShopGroup: '/order/orderBase/createOrderByShopGroup',
  confirmGetGoods: '/order/orderBase/confirmGetGoods',
  qryKuai100Express: '/order/express/qryKuai100Express',
  updateVoucher: '/order/orderBase/updateVoucher'
};

/**
 * 获取订单列表
 * @returns {{result: unknown, getList: (...params: any[]) => Promise<unknown>, loading: boolean, error: Error}}
 */
export const useQryOrderListForApp = () => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    
    return http({
      url: apiPath.qryOrderListForApp,
      method: 'get',
      data: q || {}
    }, { noAlias: true });
    
  }, {
    manual: true,
    ...reqDefaultConfig
  });
  
  return {
    result: data || {},
    loading,
    error,
    getList: runAsync
  };
};

export const useGetOrderInfoById = () => {
  const { data, loading, runAsync } = useRequest((q) => {
    return http({
      url: apiPath.getOrderInfoById,
      method: 'get',
      data: q || {}
    });
  }, { manual: true });
  
  return {
    result: data || {},
    loading,
    getDetail: runAsync,
  };
};


export const useCancelOrder = () => {
  const { data, runAsync, loading } = useRequest((q) => {
    return http({
      url: apiPath.cancelOrder,
      method: 'post',
      data: q || {}
    }, { noAlias: true });
  }, { manual: true, });
  
  return {
    result: data || {},
    cancelOrder: runAsync,
  };
};

export const useCreateOrderByShopGroup = () => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    return http({
      url: apiPath.createOrderByShopGroup,
      method: 'post',
      data: q || {}
    }, { json: true, noAlias: true });
    
  }, { manual: true });
  
  return {
    result: data || {},
    loading,
    error,
    submitOrder: runAsync
  };
};

export const useConfirmGetGoods = () => {
  const { data, loading, runAsync } = useRequest((q) => {
    return http({
      url: apiPath.confirmGetGoods,
      method: 'post',
      data: q || {},
    }, { noAlias: true });
  }, { manual: true });
  
  return {
    result: data || {},
    loading,
    receivedHandle: runAsync,
  };
};

export const useGetExpressDetail = () => {
  const { data, runAsync } = useRequest(q => {
    return http({
      url: apiPath.qryKuai100Express,
      method: 'post',
      data: q || {},
    });
  }, { manual: true });
  
  return {
    result: data,
    expressDetailHandle: runAsync
  };
};

export const useUpdateVoucher = () => {
  const { data, runAsync } = useRequest(q => {
    return http({
      url: apiPath.updateVoucher,
      method: 'post',
      data: q || {},
    }, { json: true, noAlias: true });
  }, { manual: true });
  
  return {
    result: data,
    updateVoucherHandle: runAsync
  };
}
